<template>
  <div class="not-found-map-report">
    <div class="not-found-message-container">
      <p>レポートデータが見つかりませんでした。</p>
      <p>お手数ですが、担当者までお問い合わせください。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundMapReport',
}
</script>

<style>
.not-found-map-report {
  width: 100%;
  height: 100%;
  font-size: 18px;
  text-align: center;
  background-color: #eeece7;
}

.not-found-message-container {
  margin: 0;
  position: absolute;
  top: 55%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
</style>
